export default {
    entity: 'Counterparty',
    name: 'Name',
    country: 'Country',
    createdAt: 'Created At',
    updatedAt: 'Last Updated',
    noData: 'No counterparties',
    active: 'Active',
};
